export default __webpack_public_path__ + "c66d5c1dcd9fd685245d19823013dde6.jpg";